<script setup lang="ts">
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { computed, ref, watch } from 'vue'
import { vocusMobileServerParamKey } from '@/composables/route'
import { VocusMobileRouteName } from '@/modules/vocus-mobile/routes'
import { useVocusMobileServerListQuery } from '@/queries/vocus-mobile-server'
import { Loader } from 'lucide-vue-next'

const props = defineProps<{
    active: boolean
}>()
const loadServers = ref(false)
const { data: paginatedServers, isLoading } = useVocusMobileServerListQuery({
    enabled: loadServers,
})

const servers = computed(() => {
    return paginatedServers.value?.data
})

watch(
    () => props.active,
    (active) => (loadServers.value = active)
)
</script>

<template>
    <AccordionItem value="vocusMobile" class="border-b-0">
        <AccordionTrigger
            class="py-2 px-4 text-white hover:no-underline hover:bg-neutral-600/50 data-[state=open]:bg-zinc-800"
        >
            <div class="flex items-center">
                <div class="w-6">
                    <FontAwesomeIcon :icon="['fal', 'mobile']" class="size-4!" />
                </div>
                <div class="ml-3 text-xs">Vocus Mobile</div>
            </div>
        </AccordionTrigger>
        <AccordionContent class="pb-0 text-xs text-white">
            <div v-if="isLoading" class="flex items-center space-x-2 pl-[52px] py-2">
                <Loader class="mr-2 h-4 w-4 shrink-0 opacity-50 animate-spin" />
                <span>Loading...</span>
            </div>
            <div v-else class="flex flex-col">
                <template v-for="server in servers" :key="server.uuid">
                    <RouterLink
                        :to="{
                            name: VocusMobileRouteName.MobileIndex,
                            params: {
                                [vocusMobileServerParamKey]: server.uuid,
                            },
                        }"
                        class="pl-[52px] py-2 pr-4 hover:bg-neutral-600/50 truncate"
                        >{{ server.title }}</RouterLink
                    >
                </template>
            </div>
        </AccordionContent>
    </AccordionItem>
</template>

<style scoped>
.router-link-exact-active {
    background-color: rgba(255, 255, 255, 0.1);
}
</style>
